import PadraoModel from 'src/core/model/PadraoModel.js'

export default class CaracteristicaModel extends PadraoModel {
  recurso = 'caracteristicas';
  microServico = 'automotor';
  include = null;
  searchFixo = null;
  nome = 'Características';

  colunasGrid = [
    { name: 'acoes', label: 'Ações', field: 'acoes', sortable: false, style: 'width: 50px', align: 'left' },
    { name: 'id', label: 'Cód', field: 'id', sortable: true, align: 'left', buscaTipo: 'inteiro' },
    { name: 'nome', label: 'Versão', field: 'nome', descending: true, sortable: true, align: 'left', buscaTipo: 'texto' },
    { name: 'ativo', label: 'Ativo', field: 'ativo', sortable: true, align: 'left', buscaTipo: 'boleanoSim' }
  ];

  form = {
    id: null,
    nome: null,
    ativo: null
  };

  constructor (bem) {
    super()
    this.formLimpo = Object.assign({}, this.form)
    if (bem) {
      this.recurso = 'bens-caracteristicas'
    }
  }
}
